export const RECIPIENT_LIST_LIMIT = 50
